import React from "react";
import { cn } from "@/lib/utils";
import { t } from "@/lib/i18n";

const SIZES = { sm: "text-[14px]", md: "text-[16px]", lg: "text-[22px]", xl: "text-[28px]" };

export function ContainerId({ numero, size = "md", className, digitoLabel = t("dígito verificador"), ...rest }) {  // Fix Q (2026-10-13): la app del chofer (en inglés) pasa «check digit»
  if (!numero) return null;
  const n = String(numero);
  const m = /^([A-Z]{4})(\d{6})(\d)$/.exec(n);
  if (!m) {
    return <span className={cn("font-mono font-medium", SIZES[size], className)} {...rest}>{n}</span>;
  }
  return (
    <span className={cn("font-mono inline-flex items-baseline gap-[0.45em] leading-tight", SIZES[size], className)} {...rest}>
      <span className="font-semibold">{m[1]}</span>
      <span className="font-medium">{m[2]}</span>
      <span
        className="font-medium inline-flex items-center justify-center leading-none px-[0.28em] py-[0.12em] border-[1.5px] border-current rounded-[3px] text-[0.8em]"
        aria-label={`${digitoLabel} ${m[3]}`}
      >{m[3]}</span>
    </span>
  );
}
